import React, { Component } from 'react';
import { connect } from 'react-redux';
import './GetStarted.scss';

import FooterWave from '../../../assets/images/footer-wave.png';

class GetStarted extends Component {
  render() {
    return (
      <section id="get-started">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <span className="sub-header">Create something great</span>
              <h3>Let's Get Started</h3>
              <h4>We provide extra attention to our clients and beacause of this we only take on a select number of clients at once. Apply now to see if you're a good fit.</h4>
              <a href="#" className="white-solid">Apply Now</a>
            </div>
          </div>
        </div>

        <img src={FooterWave} alt="" className="footer-wave" />
      </section>
    )
  }
}

export default connect()(GetStarted);



// WEBPACK FOOTER //
// ./src/components/Common/GetStarted/GetStarted.js